import React from 'react'
import { connect } from 'react-redux'

import { endCourse } from '../reducers'

import InstructorsCoursesList from './InstructorsCoursesList'

import { createHashHistory } from 'history'
export const history = createHashHistory()

class InstructorsCoursesInProgress extends React.Component {
  handleCourseAction = (courseId, course) => {
    history.push(`/course/instructor/${courseId}`)
  }

  render() {
    const buttonActions = [
      {
        secondary: true,
        label: 'INCHEIE CURS',
        handleAction: this.handleCourseAction,
      },
    ]
    return (
      <InstructorsCoursesList
        {...this.props}
        buttonActions={[]}
        titleLabel="Cursuri in desfasurare"
        labelDialogTitle="Sunteti sigur?"
        labelDialogCancel="Anuleaza"
        labelDialogConfirm="Confirma"
        labelDialogDescription="Aceasta actiune va incheia cursul. Va rugam confirmati"
        handleAction={this.handleCourseAction}
      />
    )
  }
}

export default connect(null, { endCourse })(InstructorsCoursesInProgress)



// WEBPACK FOOTER //
// ./src/instructors/InstructorsCoursesInProgress.js